<template>
  <div>
    <div class="navigationSort__item">
      <div class="navigationSort__title">
        {{element.title}}
      </div>
      <div class="navigationSort__actions">
        <button class="btn btn--success btn--small" type="button" @click="isOpen = !isOpen">Edit</button>
        <button class="btn btn--primary btn--small" type="button" @click="deleteNavigationItem()">Delete</button>
      </div>
    </div>
    <div class="navigationSort__edit" v-show="isOpen">
      <label class="form__label" for="title">Title:</label>
      <input type="text" class="form__input" v-model="element.title" />

      <div>
        <label class="form__label" for="title">URL:</label>
        <input type="text" class="form__input" v-model="element.url" />
      </div>

      <label>
        <input type="checkbox" :value="true" v-model="element.newTab"> Open in new tab
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation-item',
  props: ['element', 'parentNavigation'],
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    deleteNavigationItem () {
      swal({
        title: 'Please confirm this action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.parentNavigation.splice(this.parentNavigation.indexOf(this.element), 1)
          this.$emit('update:parentNavigation', this.parentNavigation)
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.navigationSort
  &__item
    border 1px solid #DFDFDF
    background #FAFAFA
    font-weight 700
    padding .5rem 1rem
    display flex
    justify-content center

    &:hover
      cursor pointer

  &__itemChild
    padding-left 20px

  &__title
    margin-right auto
    line-height 2

  &__edit
    padding .5rem 1rem
    background #fff
    border 1px solid #DFDFDF
    margin-top -.5rem
    margin-bottom 1rem
</style>



// WEBPACK FOOTER //
// src/components/Navigation/NavigationItem.vue